module.exports = __webpack_public_path__ + "img/upornia.fce002d.png";